import p5 from "p5";
import EventEmitter from "./EventEmitter";

export let p5Width;
export let p5Height;


// This function initializes and returns the p5 instance.
export function generateTexture(container1, container2) {
  return new Promise((resolve) => {

    // variables:

    //const container = document.createElement('div');

    // Variables to track when drawing is complete
    let p5InstanceReady = false;
    let p5Instance2Ready = false;

    // Variables to store p5 instances
    let p5Instance, p5Instance2;

    // Function to check if both instances are ready
    const checkIfReady = () => {
      if (p5InstanceReady && p5Instance2Ready) {
        resolve({ p5Instance, p5Instance2 });
      }
    };

          // Variables to store each answer
          let your_message = '';

          let scale = 10
          p5Width = 6378/scale//2000
          p5Height = 10630/scale///2

    //sketch:

    p5Instance = new p5((sketch) => {

      let columnwidth;
      let blockSizeWidth;
      let blockSizeHeight;

      let colour_1 = 'beige'
      let colour_2 = 'black'
      let colour_3 = 'darkorange'

      let binaryChoice;
      let data = "To the future, I want to take my past self and show him it ain't it. Because everything I ever needed is here. Right here in the light of the sun."
      let myOutput;

      let charCount = 0;
      let newCount = 0;
      let switchCount = 0;

      let jump = 0;

      // preload

      sketch.setup = () => {

        sketch.createCanvas(p5Width, p5Height); //90x150cm
        sketch.background(colour_1)
        sketch.noLoop()
        sketch.redraw()

        columnwidth = 2000 / scale
        blockSizeWidth = columnwidth / 16;
        blockSizeHeight = 125 / scale;

      }

      sketch.draw = () => {
        sketch.background(colour_1)
        sketch.noStroke();
        //sketch.noLoop()


        const msg = (your_message ?? "").toString(); // ✅ guard
        myOutput = sketch.transToBinaryShort_X2(msg);
      
        if (msg.length > 0) {
        for (let x = 0; x < sketch.width; x += columnwidth) {
          for (let y = 0; y < sketch.height; y += blockSizeHeight) {

            if (newCount === 20) {

              if (switchCount % 2 === 0) {
                colour_1 = 'black'
                colour_2 = 'beige'
              }

              else {
                colour_1 = 'beige'
                colour_2 = 'black'
              }

              switchCount++
              newCount = 0;

            }


            switch (myOutput[charCount]) {

              case '#':

                binaryChoice = 1

                break;

              case '@':

                binaryChoice = 2

                break;

              case '!':

                binaryChoice = 3

                break;

              case '&':

                binaryChoice = 4

                break;

              case '*':

                binaryChoice = 5

                break;

              case '€':

                binaryChoice = 6

                break;

              case '+':

                binaryChoice = 7

                break;

              case '_':

                binaryChoice = 8

                break;

              case '^':

                binaryChoice = 9

                break;

              case '¡':

                binaryChoice = 10

                break;

              case '∞':

                binaryChoice = 11

                break;

              case '•':

                binaryChoice = 12

                break;

              case '£':

                binaryChoice = 13

                break;

              case '=':

                binaryChoice = 14

                break;

              case ')':

                binaryChoice = 15

                break;

              case '(':

                binaryChoice = 16

                break;

            }

            sketch.fill(colour_2)
            sketch.rect(x, y, columnwidth, blockSizeHeight)

            sketch.fill(colour_1)
            sketch.rect(x, y, binaryChoice * blockSizeWidth, blockSizeHeight)

            charCount++
            newCount++
          }
        }

        for (let y = 0; y <= sketch.height; y += blockSizeHeight / 2) {
          for (let x = 0; x < sketch.width; x += columnwidth * 2 / 32) {

            if (y % blockSizeHeight === 0) {
              jump = columnwidth * 2 / 64
            }

            else {
              jump = 0;
            }

            sketch.blendMode(sketch.DIFFERENCE)
            sketch.fill(colour_1)
            sketch.rect(x + jump, y - blockSizeHeight / 4, 16 / scale, blockSizeHeight / 2)

            //ORANGE
            sketch.blendMode(sketch.BLEND)
            sketch.fill(colour_3)
            sketch.rect(x + 16 / scale + jump, y - blockSizeHeight / 4, 16 / scale, blockSizeHeight / 2)

          }

        }

        charCount = 0;
        newCount = 0;
        switchCount = 0;
        jump = 0;
      }

        //

        //p5Instance.textureNeedsUpdate = true;

        // Set the flag to true after first draw
        if (!p5InstanceReady) {
          p5InstanceReady = true;
          checkIfReady();
        }

      }

      EventEmitter.subscribe("updateData", (newData) => {
        your_message = (newData?.your_message ?? "").toString(); // ✅ guard
        sketch.redraw();
      });
      

      // BINARY

      sketch.transToBinaryShort_X2 = function (input) {
        input = (input ?? "").toString(); // ✅ guard against undefined/null
        let output = []

        for (let i = 0; i < input.length; i++) {

          let bin = input[i].charCodeAt().toString(2);
          output.push(Array(8 - bin.length + 1).join("0") + bin)
        }

        let newOutput = output.join("")

        let newNewOutput = replaceDigits(newOutput)

        function replaceDigits(str) {
          const replacements = {
            '0000': '#',
            '1111': '@',
            '1000': '!',
            '0001': '&',
            '1100': '*',
            '0011': '€',
            '1110': '+',
            '0111': '_',
            '0100': '^',
            '0010': '¡',
            '0110': '∞',
            '1001': '•',
            '1010': '£',
            '0101': '=',
            '1011': ')',
            '1101': '('
          };

          let result = '';
          const length = str.length;

          for (let a = 0; a < length; a += 4) {
            const substring = str.substr(a, 4);
            result += replacements[substring] || substring;
          }

          return result;
        }

        return newNewOutput

      }

      // SAVE PNG

      sketch.keyTyped = function () {
        if (sketch.key === '=') {
          sketch.saveCanvas('KnitPlus.png');

        }

      }

    }, container1);

    p5Instance2 = new p5((sketch) => {

      // Variables:

      let data;
      let myOutput;

      //colours
      let purple_colour = '#670099'
      let blue_colour = '#3e51ff'
      let pink_colour = 'hotpink'
      let turq_colour = 'aqua'
      let orange_colour = '#FF4500'
      let brown_colour = '#640045'
      let yellow_colour = '#f5bf00'
      let white_colour = 'white'
      let black_colour = 'black'

      sketch.setup = () => {

        sketch.createCanvas(p5Width, p5Height); // Create a 512x512 texture
        sketch.background(255, 255, 240);

      };

      sketch.draw = () => {
        sketch.background(255, 255, 240);

        // Set the flag to true after first draw
        if (!p5Instance2Ready) {
          p5Instance2Ready = true;
          checkIfReady();
        }
      };

    }, container2);

  });
}